import { Pipe, PipeTransform } from '@angular/core';
import { Field } from '../../../app/_models/field';
import { ListsHelperService } from '../_services/lists-helper.service';

@Pipe({ name: 'fieldSortBy' })

export class FieldSortByPipe implements PipeTransform {
  constructor(private listHelper: ListsHelperService) { }

  transform(fields: Field[], column: string, desc: boolean): any[] {
    if (!fields || fields.length == 0) return [];
    if (!column) return fields;
    if (desc == null) {
      desc = true;
    }
    switch (column) {
      case 'field': {
        fields.sort(this.listHelper.sortSubPropertyString(column, 'fieldName', desc));
        break;
      }
      default: {
        fields.sort(this.listHelper.sortProperty(column, desc));
        break;
      }
    }

    return fields;
  }
}
